// Foutvanger rond de inhoud van één tab. Eén kapot scherm (een onverwacht lege
// waarde in een nieuwe propositie, zoals de skills zonder cijfers op live op
// 01-11) haalt anders de hele pagina weg: React hangt bij een fout in render de
// complete boom af. Met dit vangnet blijft de kopbalk staan, zegt het scherm
// wat er mis is en kan de gebruiker opnieuw proberen of naar een andere tab.
//
// App.tsx geeft `key={activeTab}`: wisselen van tab zet het vangnet dus terug.

import { Component, type ErrorInfo, type ReactNode } from "react";

import { herlaadVoorNieuweVersie, isOudeVersieFout } from "../lib/nieuweVersie";
import { color, radius, size, weight } from "../tokens";

const vak = {
  margin: "24px 0",
  padding: "20px 24px",
  border: `1px solid ${color.border}`,
  borderRadius: radius.card,
  background: color.surface,
  color: color.ink,
  fontSize: size.body,
};

type Props = { tab: string; children: ReactNode };
type State = { fout: Error | null };

export class TabVangnet extends Component<Props, State> {
  state: State = { fout: null };

  static getDerivedStateFromError(fout: Error): State {
    return { fout };
  }

  componentDidCatch(fout: Error, info: ErrorInfo): void {
    // Blijft in de console staan voor wie meekijkt; de gebruiker krijgt de zin.
    console.error(`Scherm ${this.props.tab} kon niet worden getoond:`, fout, info.componentStack);
    if (isOudeVersieFout(fout)) herlaadVoorNieuweVersie();
  }

  render(): ReactNode {
    if (!this.state.fout) return this.props.children;
    if (isOudeVersieFout(this.state.fout)) {
      // Opnieuw proberen in dezelfde pagina helpt dan niet: het oude stuk blijft weg.
      return (
        <div role="alert" style={vak}>
          <p style={{ margin: 0, fontWeight: weight.medium }}>Er staat een nieuwe versie klaar.</p>
          <p style={{ margin: "8px 0 16px", color: color.muted }}>
            De pagina wordt herladen. Gebeurt dat niet, klik dan hieronder.
          </p>
          <button type="button" onClick={() => window.location.reload()}>
            Pagina herladen
          </button>
        </div>
      );
    }
    return (
      <div role="alert" style={vak}>
        <p style={{ margin: 0, fontWeight: weight.medium }}>Dit scherm kon niet worden getoond.</p>
        <p style={{ margin: "8px 0 16px", color: color.muted }}>
          Er ging iets mis bij het tonen van {this.props.tab}. De andere tabbladen werken gewoon.
        </p>
        <button type="button" onClick={() => this.setState({ fout: null })}>
          Opnieuw proberen
        </button>
      </div>
    );
  }
}
